(()=>{
  const track=(name,params={})=>{if(typeof window.gtag==="function")window.gtag("event",name,params);};
  const picker=document.getElementById("vehicle-exact-picker");
  const step2=document.querySelector('.guided-step[data-step="2"]');
  if(!picker||!step2)return;

  const pickup=document.getElementById("pickup-date");
  const ret=document.getElementById("return-date");
  const pickupTime=document.getElementById("pickup-time");
  const returnTime=document.getElementById("return-time");
  const typeSelect=document.getElementById("vehicle-type-pref");
  const pickerTitle=picker.querySelector(".vehicle-picker-title");
  const preview=picker.querySelector(".vehicle-preview");

  let latestAvailability={};
  let checking=false;
  let lastTrackedState="";

  const selectedNumber=()=>{
    const m=(pickerTitle?.textContent||"").match(/N\.?\s*(\d+)/i);
    return m?Number(m[1]):null;
  };
  const completePeriod=()=>Boolean(pickup?.value&&ret?.value&&pickupTime?.value&&returnTime?.value);

  const statusPanel=document.createElement("div");
  statusPanel.className="vehicle-status-panel is-unknown";
  statusPanel.hidden=true;
  statusPanel.setAttribute("aria-live","polite");
  statusPanel.innerHTML=`<span class="vehicle-status-dot" aria-hidden="true"></span><div class="vehicle-status-copy"><span>STATO DEL MEZZO · RENTHUB</span><strong>Seleziona date e orari per verificare</strong><small>Lo stato si riferisce esclusivamente al periodo richiesto.</small></div>`;
  if(preview)preview.insertAdjacentElement("afterend",statusPanel);else picker.appendChild(statusPanel);
  const statusTitle=statusPanel.querySelector("strong");
  const statusHelp=statusPanel.querySelector("small");

  const rawState=n=>{
    const v=latestAvailability[n]!==undefined?latestAvailability[n]:latestAvailability[String(n)];
    if(v===true||v==="available")return true;
    if(v===false||v==="unavailable")return false;
    return null;
  };

  function renderStatus(){
    const n=selectedNumber();
    if(!n){statusPanel.hidden=true;return;}
    statusPanel.hidden=false;
    statusPanel.classList.remove("is-available","is-unavailable","is-checking","is-unknown");

    let state="unknown";
    if(checking&&completePeriod()){
      state="checking";
      statusPanel.classList.add("is-checking");
      statusTitle.textContent="Controllo RentHub in corso…";
      statusHelp.textContent="Stiamo verificando il Furgone N."+n+" per le date e gli orari scelti.";
    }else{
      const available=rawState(n);
      if(available===true){
        state="available";
        statusPanel.classList.add("is-available");
        statusTitle.textContent=window.MASSAGOMME_SAME_DAY_MODE?"Disponibile oggi nell'orario scelto":"Disponibile per le date e gli orari scelti";
        statusHelp.textContent="Disponibilità verificata tramite RentHub. La conferma finale avviene con la prenotazione.";
      }else if(available===false){
        state="unavailable";
        statusPanel.classList.add("is-unavailable");
        statusTitle.textContent=window.MASSAGOMME_SAME_DAY_MODE?"Occupato / non disponibile oggi":"Occupato / non disponibile nel periodo scelto";
        statusHelp.textContent="Il sito può proporti automaticamente altri furgoni disponibili nello stesso periodo.";
      }else{
        statusPanel.classList.add("is-unknown");
        if(completePeriod()){
          statusTitle.textContent="Disponibilità da verificare";
          statusHelp.textContent="Completa o aggiorna la verifica per conoscere lo stato reale del Furgone N."+n+".";
        }else{
          statusTitle.textContent="Seleziona date e orari per verificare";
          statusHelp.textContent="Lo stato verrà controllato su RentHub per il periodo richiesto.";
        }
      }
    }

    const trackKey=[n,state,pickup?.value||"",pickupTime?.value||"",ret?.value||"",returnTime?.value||""].join("|");
    if(trackKey!==lastTrackedState&&(state==="available"||state==="unavailable")){
      lastTrackedState=trackKey;
      track("stato_furgone_visualizzato",{furgone_numero:n,stato:state,modalita_oggi:Boolean(window.MASSAGOMME_SAME_DAY_MODE)});
    }
  }

  const previousSetAvailability=window.MASSAGOMME_SET_AVAILABILITY;
  window.MASSAGOMME_SET_AVAILABILITY=map=>{
    if(typeof previousSetAvailability==="function")previousSetAvailability(map);
    latestAvailability=map&&typeof map==="object"?{...map}:{};
    checking=false;
    setTimeout(renderStatus,0);
  };

  document.addEventListener("massagomme:availability:request",()=>{
    checking=true;
    setTimeout(renderStatus,0);
  });

  picker.querySelectorAll(".vehicle-option").forEach(option=>{
    option.addEventListener("click",()=>setTimeout(renderStatus,0));
  });

  [pickup,ret,pickupTime,returnTime,typeSelect].forEach(el=>el?.addEventListener("change",()=>setTimeout(renderStatus,0)));
  if(pickerTitle)new MutationObserver(()=>renderStatus()).observe(pickerTitle,{childList:true,subtree:true,characterData:true});

  try{localStorage.removeItem("massagomme:last-vehicle-choice:v1");}catch(e){}

  renderStatus();
})();